// extracted by mini-css-extract-plugin
export default {"comics":"scroll_comics__7bwQK","button":"scroll_button__eIvEI"};